@import '../../styles/mixins';
@import '../../styles/variables';

.actions {
  border-radius: 8px;
  border: 1px solid var(--neutral-10);
  background: var(--neutral-0);
  display: flex;
  column-gap: 2px;
}

.truncated {
  @include line-clamp(4);
}
